import { render, staticRenderFns } from "./EditOrders.vue?vue&type=template&id=4fcb8d9e&scoped=true&"
import script from "./EditOrders.vue?vue&type=script&lang=js&"
export * from "./EditOrders.vue?vue&type=script&lang=js&"
import style0 from "./EditOrders.vue?vue&type=style&index=0&id=4fcb8d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcb8d9e",
  null
  
)

export default component.exports